module.exports = __webpack_public_path__ + "static/media/logo_ccmb.1efa6228.jpg";